<div class="screen-container">
  <app-card [title]="'startImprove.title' | translate">
    <div left-content>
      <div class="text-container">
        <p class="first-paragraph">{{ "startImprove.firstParagraph" | translate }}</p>
        <p>
          {{ "startImprove.secondParagraph" | translate: { steps: flowService.questionsLength } }}
        </p>
        <p>
          {{
          "startImprove.thirdParagraph"
            | translate: { autoprocessing: autoprocessing | localizedDate : 'HH:mm' }
          }}
        </p>
        <p>{{ "startImprove.fourthParagraph" | translate }}</p>
      </div>
      <div actions class="actions">
        <button
          (click)="handleContinueButtonClick()"
          mat-flat-button
          color="primary"
        >
          {{ "startImprove.buttonText" | translate }}
        </button>
      </div>
    </div>
    <div right-content>
      <app-contact></app-contact>
    </div>
  </app-card>
</div>
